import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { StatisticsRouteName } from '@pages/statistics-page/statistics.module';

@Component({
  imports: [DvTabsComponent, RouterOutlet],
  selector: 'app-statistics-tabs',
  templateUrl: './statistics-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./statistics-tabs.component.scss'],
})
export class StatisticsTabsComponent {
  private translateService = inject(TranslateService);

  tabLinks: DvTabLink[];

  constructor() {
    this.tabLinks = [
      {
        label: this.translateService.instant('Statistics.Tabs.Score'),
        link: StatisticsRouteName.Score,
        id: StatisticsRouteName.Score,
      },
      {
        label: this.translateService.instant('Statistics.Tabs.Triggers'),
        link: StatisticsRouteName.Triggers,
        id: StatisticsRouteName.Triggers,
      },
      {
        label: this.translateService.instant('Statistics.Tabs.Emission'),
        link: StatisticsRouteName.Emission,
        id: StatisticsRouteName.Emission,
      },
      {
        label: this.translateService.instant('Statistics.Tabs.Mileage'),
        link: StatisticsRouteName.Mileage,
        id: StatisticsRouteName.Mileage,
      },
      {
        label: this.translateService.instant('Statistics.Tabs.Trips'),
        link: StatisticsRouteName.Trips,
        id: StatisticsRouteName.Trips,
      },
      {
        label: this.translateService.instant('Statistics.Tabs.Heatmap'),
        link: StatisticsRouteName.HeatMap,
        id: StatisticsRouteName.HeatMap,
      },
    ];
  }
}
